import React from 'react'
import Helmet from 'react-helmet'

// App content
import readersChoicePhoto from '../assets/ReadersChoiceTeamPic_2018.jpg'

const defaultDescription =
  'Collins Orthodontics is the best orthodontist in Rochester, Minnesota. Give us a call to schedule your appointment.'
const defaultTitle = 'Orthodontist Rochester MN | Collins Orthodontics'
const defaultImage = readersChoicePhoto
const defaultKeywords =
  'orthodontist, orthodontics, rochester mn, dental, teeth, whitening, braces, invisalign, collins, grant collins'

const mainScript = {
  type: 'application/ld+json',
  innerHTML: `{
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": "Collins Orthodontics",
    "url": "https://www.rochesterorthdontics.com",
    "sameAs": [
      "https://www.facebook.com/rochesterorthodontics",
      "https://www.instagram.com/thebracesguy",
      "https://plus.google.com/+CollinsOrthodonticsRochester/about",
      "https://rochesterorthodontics.blogspot.com/",
      "https://www.youtube.com/c/TheBracesGuyOfficial"
    ]
  }`,
}

export default ({
  description = defaultDescription,
  title = defaultTitle,
  image = defaultImage,
  keywords = defaultKeywords,
  script,
}) => (
  <Helmet
    title={title}
    meta={[
      { property: 'description', content: description },
      { property: 'keywords', content: keywords },
      { property: 'image', content: image },
    ]}
    script={[Object.assign(mainScript, script)]}
  >
    <meta property="og:description" content={description} />
    <meta property="twitter:description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:image" content={image} />
    <meta property="og:image" content={image} />
    <meta property="twitter:image" content={image} />
  </Helmet>
)
